<button
  type="button"
  class="w-full text-left flex flex-col gap-2 rounded-lg border border-surface-200 dark:border-surface-700 bg-surface-0 dark:bg-surface-900 px-4 py-3 hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors cursor-pointer"
  (click)="open.emit(ticket().id)"
>
  <!-- top row: ticket number + created-at pill -->
  <div class="flex items-start justify-between gap-2">
    <span class="font-semibold">
      @if (ticket().ticket_number) {
        {{ 'support.chat.ticketNumber' | translate: { number: ticket().ticket_number } }}
      } @else {
        {{ 'support.chat.untitledTicket' | translate }}
      }
    </span>
    <span
      class="shrink-0 text-sm text-surface-500 dark:text-surface-400 rounded-md bg-surface-100 dark:bg-surface-800 px-2 py-0.5"
    >
      {{ ticket().created_at | date: 'shortDate' }}
    </span>
  </div>

  <!-- last-message preview -->
  @if (preview()) {
    <p class="text-surface-600 dark:text-surface-300 line-clamp-2 m-0">
      {{ preview() }}
    </p>
  }

  <!-- bottom row: status + last activity + unread -->
  <div class="flex items-center gap-2">
    <p-tag [value]="statusKey() | translate" [severity]="statusSeverity()" />
    @if (ticket().last_message_at) {
      <span class="text-sm text-surface-500 dark:text-surface-400">
        {{ ticket().last_message_at | date: 'short' }}
      </span>
    }
    @if (ticket().unread_count) {
      <p-badge
        [value]="ticket().unread_count"
        severity="danger"
        class="ml-auto"
      />
    }
  </div>
</button>
